const NeedTypeEnum = {
 PROTECTION_FOR_MY_FAMILY: "protection_for_my_family",
 PROTECTION_FOR_MY_HEALTH: "protection_for_my_health",
 GROW_MY_MONEY: "grow_my_money",
 SAVE_FOR_CHILDREN: "save_for_children",
 SAVE_FOR_RETIREMENT: "save_for_retirement",
}

export default NeedTypeEnum;
